import '../global.css';

import { useEffect } from 'react';
import { Stack } from 'expo-router';
import * as SplashScreen from 'expo-splash-screen';
import { KeyboardProvider } from 'react-native-keyboard-controller';

import { LoginRoot } from '../providers/LoginRoot';
import { useLanguageSetting } from '../hooks/useLanguageSetting';
import { getBuildInfo } from '../constants/buildInfo';

SplashScreen.preventAutoHideAsync();

export default function RootLayout() {
  useLanguageSetting();

  console.log('[Build]', getBuildInfo());

  useEffect(() => {
    SplashScreen.hideAsync();
  }, []);

  return (
    <KeyboardProvider>
      <LoginRoot>
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: 'transparent' },
          }}
        >
          <Stack.Screen name='index' />
          <Stack.Screen name='sso-login' />
          <Stack.Screen name='forgot-password' />
          <Stack.Screen name='reset-password' />
          <Stack.Screen name='magic-link' />
          <Stack.Screen name='magic-link-sent' />
          <Stack.Screen name='token-login' />
          <Stack.Screen name='impersonation-callback' />
          <Stack.Screen name='maintenance' />
          <Stack.Screen name='signed-out' />
        </Stack>
      </LoginRoot>
    </KeyboardProvider>
  );
}
